import React from "react";

export interface ITabContext {
  /** Active tab ID */
  activeItem?: string | null;
  /** Called when new tab is selected */
  onSelect?: (id: string) => void;
  /** Called on tab mount */
  createTab?: (tabId: string | string[]) => void;
  /** Called on tab unmount */
  removeTab?: (tabId: string | string[]) => void;
}

export const TabSwitcherContext = React.createContext<ITabContext>({
  activeItem: null,
  onSelect: null,
});
